module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicCondensed-Bold-953da5eb380cd07c2e98def59771f39b.woff2";